import React from 'react';
import ProductManagement from "../components/ProductManagememt/ProductManagement";

const ProductManagementPage = () => {
    return <ProductManagement/>;
}

export default ProductManagementPage;